// extracted by mini-css-extract-plugin
export default {"daysAction":"daysAction-b73e2003","content":"content-b8e9eb9d","urgent":"urgent-aeca8f91","add":"add-fa62374e","selects":"selects-f108a93a"};